import React, { useState } from "react";
import { BarChart, Bar, XAxis, Tooltip, ResponsiveContainer, Legend } from "recharts";
import '../insightsLoginTab/InsightsLoginTab.css'

const allMonths = [ "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep"];

// Sample yearly data
const yearlyData = {
  2024: [
    { month: "Mar", value: 25000 },
    { month: "Apr", value: 10000 },
    { month: "May", value: 30000 },
    { month: "Jun", value: 28000 },
    { month: "Jul", value: 18000 },
    { month: "Aug", value: 22000 },
    { month: "Sep", value: 34100 },
  ],
  2023: [
    { month: "Mar", value: 20000 },
    { month: "Apr", value: 8000 },
    { month: "May", value: 25000 },
    { month: "Jun", value: 27000 },
    { month: "Jul", value: 16000 },
    { month: "Aug", value: 21000 },
    { month: "Sep", value: 32000 },
  ],
};

const highlightMonths = ["Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep"];

const ChartComponent = () => {
  const [selectedYear, setSelectedYear] = useState(2024);

  // Ensure all months exist, filling missing ones with value 0
  const completeData = allMonths.map((month) => {
    const found = yearlyData[selectedYear]?.find((item) => item.month === month);
    return found || { month, value: 0 };
  });

  return (
    <div style={{ width: "100%", margin: "auto", textAlign: "center", fontFamily: "Arial" }}>
      {/* <h2>{selectedYear} Monthly Data</h2> */}

      {/* Year selection buttons */}
      <div style={{ marginBottom: "20px" }}>
        {[2019, 2020, 2021, 2022, 2023, 2024].map((year) => (
          <button
            key={year}
            onClick={() => setSelectedYear(year)}
            style={{
              margin: "5px",
              padding: "7px 10px",
              borderRadius: "8px",
              border: "1px solid #ff69b4",
              backgroundColor: selectedYear === year ? "rgba(253, 89, 217, 1)" : "white",
              color: selectedYear === year ? "white" : " rgba(120, 116, 134, 1)",
              cursor: "pointer",
            }}
          >
            {year}
          </button>
        ))}
      </div>

      {/* Bar Chart */}
      <ResponsiveContainer width="100%" height={400} >
        <BarChart data={completeData} margin={{ top: 20, right: 30, left: 20, bottom: 50 }} >
          <XAxis dataKey="month" tick={{ fontSize: 14 }} />
          {/* <YAxis /> */}
          <Tooltip />
          <Legend />
          
          {/* Default bars */}
          <Bar dataKey="value" fill="rgba(254, 163, 234, 1)" radius={[10, 10, 10, 10]} />

          {/* Highlighted bars for selected months */}
          <Bar
            dataKey="value"
            data={completeData.filter((item) => highlightMonths.includes(item.month))}
            fill="rgba(253, 89, 217, 1)"
            radius={[10, 10, 10, 10]}
          />
        </BarChart>
      </ResponsiveContainer>

      {/* Month Labels Below */}
      {/* <div style={{ display: "flex", justifyContent: "center", marginTop: "10px", flexWrap: "wrap" }}>
        {allMonths.map((month) => (
          <div key={month} style={{ margin: "0 10px", fontSize: "14px", fontWeight: "bold", color: "#ff69b4" }}>
            {month}
          </div>
        ))}
      </div> */}

      {/* Weekly Breakdown Button */}
      {/* <button
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          borderRadius: "10px",
          border: "none",
          backgroundColor: "rgba(255, 226, 249, 1)",
          color: "rgba(120, 116, 134, 1)",
          cursor: "pointer",
          fontSize: "16px",
        }}
      >
        View weekly breakdown
      </button> */}

      <div className="accordion-content button-accordion-box">
        <div class="accordion" id="accordionExample">
          <div class="accordion-item">
            <h2 class="accordion-header">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
              View weekly breakdown
              </button>
            </h2>
            <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
              <div class="accordion-body">
                  <div className="breakdown-sec">
                    <div className="top-breakdown">
                        <p>September 2024</p>
                        <h2>$34,100 AUD</h2>
                    </div>
                    <div className="breakdown-com-content">
                      <div className="breakdown-box">
                        <h6>1 Aug - 7 Aug</h6>
                        <span>$5,000 AUD</span>
                      </div>
                      <div className="breakdown-box">
                        <h6>8 Aug - 14 Aug</h6>
                        <span>$5,100 AUD</span>
                      </div>
                      <div className="breakdown-box">
                        <h6>15 Aug - 21 Aug</h6>
                        <span>$5,000 AUD</span>
                      </div>
                      <div className="breakdown-box">
                        <h6>22 Aug - 28 Aug</h6>
                        <span>$5,000 AUD</span>
                      </div>
                      <div className="breakdown-box">
                        <h6>29 Aug - 31 Aug</h6>
                        <span>$14,000 AUD</span>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

function App() {
  return <ChartComponent />;
}

export default App;
